interface Member {
  image: string;
  name: string;
  title: string;
  description: string;
  linkedin?: string;
  mail?: string;
  twitter?: string;
}

export const members: Member[] = [
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/chris.png`,
    name: "Christopher Perdek",
    title: "CEO & FOUNDER",
    description:
      "Over 8 years of experience in strategy, partnerships, and innovation in Financial Services, Blockchain, and Technology. A keen ability to spot great ideas ahead of others. An exceptional strategist and seasoned trader.",
    linkedin: "https://www.linkedin.com/in/krzysztof-perdek",
    mail: "christopher@uniqly.io",
    twitter: "https://twitter.com/Chris_Perdek",
  },
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/matt.jpeg`,
    name: "Matt Bosek",
    title: "Advisory Board",
    description:
      "More than 9 years of international experience in startup and enterprise environments. Building large-scale applications in the Fintech industry for one of the largest banks - HSBC and the Biotechnology industry for PCR projects in QIAGEN.",
    linkedin: "https://www.linkedin.com/in/mateusz-bosek",
    mail: "matt@uniqly.io",
  },
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/jakub-gajdamowicz.png`,
    name: "Jakub Gajdamowicz",
    title: "COO & CO-FOUNDER",
    description:
      "Engaged with the entrepreneurial market in Poland and development of a chain of Academic Accelerators. Entrepreneur, Startup Advisor, a digital marketer with more than 15 years of experience. Involved in crypto space since 2013.",
    twitter: "https://twitter.com/otakujake_pro",
    linkedin: "https://www.linkedin.com/in/jakubgajdamowicz/",
    mail: "jakub@uniqly.io",
  },
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/mateusz-kara.png`,
    name: "Mateusz Kara",
    title: "HEAD OF LEGAL",
    description:
      "Business oriented lawyer focused mostly on Blockchain projects, tokenization, cryptocurrency, AML and Fintech. Mateusz is also a CEO of ARI10, Co-owner of accounting office TAXO and Partner in Gras i Wspolnicy Law Office.",
    linkedin: "https://www.linkedin.com/in/mateusz-kara",
  },
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/michael-kaleta.jpg`,
    name: "Michael Kaleta",
    title: "ADVISORY BOARD",
    description:
      "Executive with experience of spearheading complex Sales & BD operations at various high-growth startups in Europe and North America. Specializing in identifying key VC partnerships and focusing on driving revenue, profit performance and valuation increase.",
    linkedin: "https://www.linkedin.com/in/michael863",
  },
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/sara-machna.png`,
    name: "Sara Machna",
    title: "HEAD OF FINANCES",
    description:
      "Over 7 years experience in the finance area at accounting, audit, building financial - accounting system for enterpreneurs. Responsible for general finance & operation system at Uniqly. Love her job!",
    linkedin: "https://www.linkedin.com/in/sara-machna",
    twitter: "https://twitter.com/Saram_ath",
  },
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/michal.jpeg`,
    name: "Michał Affa",
    title: "HEAD OF IT",
    description:
      "Senior Full Stack Developer with more than 7 years of experience. Team player with a sharp eye for detail, problem-solving and solution-finding skills. Michał worked on apps as a person responsible for optimizations and reducing technological debt.",
    linkedin: "https://www.linkedin.com/in/micha%C5%82-affa-b7289a8b/ ",
  },
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/photo_2025-03-14 14.59.02.jpeg`,
    name: "Karolina Stasica",
    title: "GROWTH MANAGER",
    description:
      "Growth Manager aiming to drive scalable growth through data-driven strategies and a deep understanding of consumer behavior and market trends. Passionate about innovation, startups, and leveraging technology to fuel business growth. Over 3 years of experience in Web3 and marketing.",
    mail: "caroline@uniqly.io",
    linkedin: "https://www.linkedin.com/in/karolina-stasica-774478216/",
  },
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/f.wroblewski.png`,
    name: "Filip Wróblewski",
    title: "BUSINESS DEVELOPMENT MANAGER",
    description:
      "Several years of experience in working with start-ups in sales and building operational processes in marketing and sales departments. Filip builds and supports the daily operational activity together with the Uniqly team.",
    linkedin: "https://www.linkedin.com/in/filip-wróblewski-10214b161",
    mail: "filip@uniqly.io",
    twitter: "https://twitter.com/filip_ath",
  },
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/lukasz-tadla.png`,
    name: "Łukasz Tadla",
    title: "HEAD OF TOKENOMICS",
    description:
      "Present in crypto since 2020 and it's already been more than a job for him, but also his biggest hobby and passion. At Uniqly, he is responsible for tokenomics modeling, expertise in navigating Web3 and knowledge of DeFi protocols. In his spare time: full-time Degen.",
    twitter: "https://twitter.com/derteil00",
    linkedin: "https://www.linkedin.com/in/lukasztadla/",
  },
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/bogdan.jpg`,
    name: "Bogdan Sinicki",
    title: "BLOCKCHAIN DEVELOPER",
    description:
      "Developer with over 6 years of experience, the last 3 years has spent in the blockchain industry. Bogdan has a good knowledge of project and team management, providing valuable support to Uniqly technical part.",
    linkedin: "https://www.linkedin.com/in/bogdan-sinicki/",
    twitter: "https://twitter.com/spockyeth",
  },
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/mateusz-chrzanowski.jpg`,
    name: "Mateusz Chrzanowski",
    title: "FULL-STACK DEVELOPER",
    description:
      "Developer with over 4 years of experience. Mateusz is always excited about learning new things and doing programming challenges. He loves travelling and extreme sports.",
    linkedin: "https://www.linkedin.com/in/mateusz-chrzanowski/",
  },
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/pawel-lechocki.jpg`,
    name: "Pawel Lechocki",
    title: "FULL-STACK DEVELOPER",
    description:
      "Full-Stack Developer with a specialisation in Web3. Frequent hackathon participant. His previous experience includes a technical role in EY's blockchain team. At Uniqly, he leverages his background to drive innovation and contribute to the company's Web3 initiatives, and more.",
    linkedin: "https://www.linkedin.com/in/lechockipawel/",
    twitter: "https://twitter.com/kryptopauldev",
  },
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/sebastian-oldak.png`,
    name: "Sebastian Ołdak",
    title: "FULL-STACK DEVELOPER",
    description:
      "Developer and Web3 enthusiast that likes to try new technologies. With previous background in sport, he is always looking for a challenges. Passionated about martial arts and fitness.",
    linkedin: "https://www.linkedin.com/in/sebastian-oldak/",
  },
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/jakub-sikora.jpg`,
    name: "Jakub Sikora",
    title: "JUNIOR DEVELOPER",
    description:
      "Junior Developer excited about learning new technologies. Passionate about Web3, design and fashion. He loves taking part in community meetings. Find him and ask about Uniqly - he'll be happy to tell you everything about it.",
    linkedin: "https://www.linkedin.com/in/jakub-sikora-307513245/",
    twitter: "https://twitter.com/verzotokumpel",
  },
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/damian-grudzinski.png`,
    name: "Damian Grudzinski",
    title: "HEAD OF GRAPHIC DESIGN",
    description:
      "Graphic Designer with almost twenty years of experience, who gave his soul to the devil for a few good Alphas. Damian is responsible for the entire graphic department, managing the work and ensuring a consistent and professional style of Uniqly.",
    linkedin: "https://www.linkedin.com/in/damian-grudziński-14553a164/",
    twitter: "https://x.com/CryptoEvangelio",
  },
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/mike-brogowski.jpg`,
    name: "Mike Brogowski",
    title: "3D DESIGNER",
    description:
      "More than 20 years experience in all fields of graphic design, 10 years of experience in 3D, 2 years experience as Lecturer. Responsible for all 3D things at Uniqly.",
    linkedin: "https://www.linkedin.com/in/mike-brogowski-54583132",
  },
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/nina-pumey.png`,
    name: "Niña Niness Espiritu Pen/Pumey",
    title: "GRAPHIC ARTIST",
    description:
      "With years of experience from creating digital artworks, Pumey dives into the world of Web3 to show her talent with the ability to challenge and adapt on any kind art styles. Pumey is also responsible for creating graphic design for Uniqly.",
    twitter: "https://twitter.com/pumey_arts",
  },
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/kamil-peschke.jpg`,
    name: "Kamil Peschke",
    title: "COORDINATOR DELIVERY",
    description:
      "Several years of experience in management positions in the areas of logistics, delivery and inventory management in industries such as micromobility, retail and food supplements. At Uniqly he is responsible for the shipping process of physicals redeems.",
    linkedin: "",
  },
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/james.jpg`,
    name: "James Okafor",
    title: "COMMUNITY MANAGER",
    description:
      "Very charismatic, endearing and knowledgeable, James utilizes his high level of experience and vast knowledge of PR and personnel management to build a cohesive and devoted investor community for Uniqly.",
    linkedin: "",
  },
  {
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/teamPage/esmino.jpg`,
    name: "K Esmino",
    title: "COMMUNITY MANAGER",
    description:
      "Several Years of Experience being a Community Manager, Very well Committed and knowledgeable, K utilizes his experience and skills to improve and manage the community to build connections between the investor and for Uniqly.",
    linkedin: "",
  },
];
